import { BonusProductQRCodeStatus } from '../data/common';
import instance from './API';
import { trim } from 'lodash';

const bonusProductAPI = {
  get: (id) => {
    return instance.get(`/BonusProduct/${id}`);
  },

  getList: (status, keyword, isPromo, isReferralCode, count, page) => {
    return instance.get(`/BonusProduct`, {
      params: {
        status: status,
        keyword: keyword,
        isPromo: isPromo,
        isReferralCode: isReferralCode,
        page: page,
        count: count,
      },
    });
  },

  create: (
    name,
    type,
    storeId,
    status,
    onSaleDate,
    offSaleDate,
    description,
    expriyDateDay,
    bonusPoint,
    cash,
    quantity,
    mainImage,
    subImages,
    barcode,
    isPromo,
    allowGift,
    isBirthdayGift,
    isNoTimeLimit,
    promoCompatibility,
  ) => {
    const formData = new FormData();

    formData.append('Name', name);
    formData.append('Type', type);
    formData.append('Status', status);
    formData.append('Description', description);
    formData.append(
      'ExpriyDateDay',
      trim(expriyDateDay) === '' ? 0 : expriyDateDay,
    );
    formData.append('BonusPoint', bonusPoint);
    formData.append('Quantity', quantity);
    formData.append('MainImage', mainImage);
    formData.append('IsPromo', isPromo);
    formData.append('AllowGift', allowGift);
    formData.append('IsBirthdayGift', isBirthdayGift);
    formData.append('IsNoTimeLimit', isNoTimeLimit === true ? true : false);

    if (
      promoCompatibility !== null &&
      promoCompatibility !== undefined &&
      promoCompatibility !== ''
    ) {
      formData.append('PromoCompatibility', promoCompatibility);
    }

    if (parseInt(storeId, 10) > 0) {
      formData.append('StoreId', storeId);
    }

    if (barcode && barcode !== null) {
      formData.append('Barcode', barcode);
    }

    if (onSaleDate) {
      formData.append('OnSaleDate', onSaleDate);
    }

    if (offSaleDate) {
      formData.append('OffSaleDate', offSaleDate);
    }

    if (cash) {
      formData.append('Cash', cash);
    }

    if (Array.isArray(subImages)) {
      subImages.map((subImage) => {
        formData.append('SubImage', subImage);
      });
    }

    return instance.post('/BonusProduct', formData);
  },

  update: (
    id,
    name,
    type,
    storeId,
    status,
    onSaleDate,
    offSaleDate,
    description,
    expriyDateDay,
    bonusPoint,
    cash,
    quantity,
    mainImage,
    mainImageId,
    subImages,
    deleteImageIds,
    barcode,
    isPromo,
    allowGift,
    isBirthdayGift,
    isNoTimeLimit,
    promoCompatibility,
  ) => {
    const formData = new FormData();

    formData.append('Name', name);
    formData.append('Type', type);
    formData.append('Status', status);
    formData.append('Description', description);
    formData.append(
      'ExpriyDateDay',
      trim(expriyDateDay) === '' ? 0 : expriyDateDay,
    );
    formData.append('BonusPoint', bonusPoint);
    formData.append('Quantity', quantity);
    formData.append('IsPromo', isPromo);
    formData.append('AllowGift', allowGift);
    formData.append('IsBirthdayGift', isBirthdayGift);
    formData.append('IsNoTimeLimit', isNoTimeLimit === true ? true : false);

    if (
      promoCompatibility !== null &&
      promoCompatibility !== undefined &&
      promoCompatibility !== ''
    ) {
      formData.append('PromoCompatibility', promoCompatibility);
    }

    if (parseInt(storeId, 10) > 0) {
      formData.append('StoreId', storeId);
    }

    if (barcode && barcode !== null) {
      formData.append('Barcode', barcode);
    }

    if (mainImage) {
      formData.append('MainImage', mainImage);
    }

    if (mainImageId) {
      formData.append('MainImageId', mainImageId);
    }

    if (onSaleDate) {
      formData.append('OnSaleDate', onSaleDate);
    }

    if (offSaleDate) {
      formData.append('OffSaleDate', offSaleDate);
    }

    if (cash) {
      formData.append('Cash', cash);
    }

    if (Array.isArray(subImages)) {
      subImages.map((subImage) => {
        formData.append('SubImage', subImage);
      });
    }

    if (deleteImageIds) {
      formData.append('DeleteImageId', deleteImageIds);
    }

    return instance.put(`/BonusProduct/${id}`, formData);
  },

  setStatus: (id, status) => {
    return instance.patch(`/BonusProduct/${id}`, undefined, {
      params: {
        status: status,
      },
    });
  },

  delete: (id) => {
    return instance.patch(`/BonusProduct/${id}`, undefined, {
      params: {
        status: 2,
      },
    });
  },

  getRecommendList: () => {
    return instance.get('/BonusProduct/Recommend');
  },

  addRecommend: (id, sort) => {
    return instance.post(`/SortBonusProduct/${id}`, undefined, {
      params: {
        order: sort,
      },
    });
  },

  setRecommendSort: (id, sort) => {
    return instance.post(`/SortBonusProduct/${id}`, undefined, {
      params: {
        order: sort,
      },
    });
  },

  removeRecommend: (id) => {
    return instance.delete(`/SortBonusProduct/${id}`);
  },

  getUserBonusProductList: (page, count, searchs) => {
    return instance.get('/UserBonusProduct', {
      params: {
        page: page,
        count: count,
        startat:
          searchs && trim(searchs.startUseDate) !== ''
            ? searchs.startUseDate
            : undefined,
        endat:
          searchs && trim(searchs.endUseDate) !== ''
            ? searchs.endUseDate
            : undefined,
        type:
          searchs && trim(searchs.bonusProductType) !== ''
            ? searchs.bonusProductType
            : undefined,
        status:
          searchs && trim(searchs.userBonusProductStatus)
            ? searchs.userBonusProductStatus
            : undefined,
        keyword:
          searchs && trim(searchs.keyword) !== '' ? searchs.keyword : undefined,
        isPromo: searchs && searchs.isPromo === true ? true : undefined,
        isReferralCode:
          searchs && searchs.isReferralCode === true ? true : undefined,
      },
    });
  },

  getReferralCode: (bonusProductId) => {
    return instance.get(`/BonusProduct/${bonusProductId}/Code`);
  },

  createReferralCode: (bonusProductId, data) => {
    return instance.post(
      `/BonusProduct/${bonusProductId}/Code?code=${data.code}&startDate=${data.startDate}&endDate=${data.endDate}&isForEvent=${data.isForEvent}&isUnlimited=${data.isUnlimited}`,
    );
  },

  updateReferralCode: (bonusProductId, codeId, data) => {
    return instance.put(
      `/BonusProduct/${bonusProductId}/Code/${codeId}?code=${data.code}&startDate=${data.startDate}&endDate=${data.endDate}&isForEvent=${data.isForEvent}&isUnlimited=${data.isUnlimited}`,
    );
  },

  deleteReferralCode: (bonusProductId, codeId) => {
    return instance.delete(`/BonusProduct/${bonusProductId}/Code/${codeId}`);
  },

  getQRCodes: (
    page,
    count,
    status = BonusProductQRCodeStatus.ALL,
    bonusProductId = undefined,
    productPackageId = undefined,
  ) => {
    let params = {
      page: page,
      count: count,
      status: status,
      productId: trim(bonusProductId) !== '' ? bonusProductId : '',
      productPackageId: trim(productPackageId) !== '' ? productPackageId : '',
    };

    return instance.get('/BonusProduct/QRCode', {
      params: params,
    });
  },

  addQRCodes: (bonusProductId, count) => {
    const params = {
      productId: bonusProductId,
      count: count,
    };

    return instance.post('/BonusProduct/QRCode', undefined, {
      params: params,
    });
  },

  qrcodeLinkUser: (
    qrcode,
    productPackageId = undefined,
    userId,
    isConsignment = false,
    userPayingMemberId = undefined,
  ) => {
    let params = {
      qrcode: qrcode,
      userId: userId,
      productPackageId: trim(productPackageId) !== '' ? productPackageId : '',
      isConsignment: isConsignment === true ? true : false,
    };

    if (userPayingMemberId) {
      params.userPayingMemberId = userPayingMemberId;
    }

    return instance.post('BonusProduct/QRCode/Link', undefined, {
      params: params,
    });
  },

  groupQRCodeLinkUser: (
    groupQRCode,
    productPackageId = undefined,
    userId,
    isConsignment = false,
    userPayingMemberId = undefined,
  ) => {
    let params = {
      qrcode: groupQRCode,
      userId: userId,
      productPackageId: trim(productPackageId) !== '' ? productPackageId : '',
      isConsignment: isConsignment === true ? true : false,
    };

    if (userPayingMemberId) {
      params.userPayingMemberId = userPayingMemberId;
    }

    return instance.post('BonusProduct/QRCode/Group/Link', undefined, {
      params: params,
    });
  },

  paperLinkUser: (
    startAt,
    endAt,
    productPackageId = undefined,
    userId,
    isConsignment = false,
    userPayingListId = undefined,
  ) => {
    let params = {
      startAt: startAt,
      endAt: trim(endAt) === '' ? startAt : endAt, // 只有一筆序號時，endAt 跟 startAt 一樣即可
      userId: userId,
      productPackageId: trim(productPackageId) !== '' ? productPackageId : '',
      isConsignment: isConsignment === true ? true : false,
    };

    if (userPayingListId) {
      params.userPayingMemberId = userPayingListId;
    }

    return instance.post('BonusProduct/Paper/Link', undefined, {
      params: params,
    });
  },

  qrcodeUse: (qrcode, useUserId) => {
    return instance.post('BonusProduct/QRCode/Scan', undefined, {
      params: {
        qrCode: qrcode,
        userId: trim(useUserId) !== '' ? useUserId : undefined,
      },
    });
  },

  getQRCodeGroups: (page, count, startAt, endAt) => {
    return instance.get('BonusProduct/QRCode/Group', {
      params: {
        page: page,
        count: count,
        startAt: trim(startAt) !== '' ? startAt : undefined,
        endAt: trim(endAt) !== '' ? endAt : undefined,
      },
    });
  },

  createQRCodeGroups: (quantity) => {
    return instance.post('BonusProduct/QRCode/Group', undefined, {
      params: {
        count: quantity,
      },
    });
  },

  getQRCodeGroupDetail: (groupId) => {
    return instance.get(`BonusProduct/QRCode/Group/${groupId}`);
  },

  removeQRCodeGroup: (groupId, qrcode) => {
    return instance.delete(`BonusProduct/QRCode/Group/${groupId}`, {
      params: {
        qrcodeValue: qrcode,
      },
    });
  },

  groupQRCode: (groupQRCode, qrcode) => {
    return instance.post('BonusProduct/QRCode/Group', undefined, {
      params: {
        groupQrcodeValue: groupQRCode,
        qrcodeValue: qrcode,
      },
    });
  },

  assignCouponToUser: (bonusProductId, userId, number) => {
    return instance.post('BonusProduct/Giveaway', undefined, {
      params: {
        customerId: userId,
        bonusproductId: bonusProductId,
        number: number,
      },
    });
  },

  restoreUserProduct: (userProductId) => {
    return instance.post('/RestoreUserProduct', undefined, {
      params: {
        userProductId,
      },
    });
  },
};

export default bonusProductAPI;
